import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import truncate from "lodash/truncate";

import Toast from "shared/toast";
import LoaderOverlay from "shared/react_components/LoaderOverlay";

import { commentText } from "./styles/Comments.module.scss";

const DeleteCommentConfirmationModal = ({ hashid, onDelete, richText, isOpen, toggle }) => {
  const [loading, setLoading] = useState(false);

  const onConfirm = async (hashid) => {
    try {
      setLoading(true);
      await onDelete(hashid);
    } catch (error) {
      Toast.error({
        title: "Error deleting comment",
        message: "An error occurred while trying to delete your comment. Please try again."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader>Delete comment</ModalHeader>
      <LoaderOverlay loading={loading}>
        <ModalBody>
          Are you sure you want to delete this message? This cannot be undone.
          <div className={classNames(commentText, "border rounded p-3 mt-3")} data-test-id="delete-comment-text">
            {truncate(richText, { length: 100 })}
          </div>
        </ModalBody>
      </LoaderOverlay>
      <ModalFooter>
        <Button onClick={toggle} data-test-id="cancel-button">Cancel</Button>
        <Button color="danger" onClick={() => onConfirm(hashid)} data-test-id="delete-button">
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteCommentConfirmationModal.propTypes = {
  hashid: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  richText: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default DeleteCommentConfirmationModal;
